import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import CustomerBeaconList from '../components/CustomerBeaconList';
import AppModel from '../DataModel/AppModel';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import ModeEdit from 'material-ui/svg-icons/editor/mode-edit';
import Add from 'material-ui/svg-icons/content/add';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import right_corner_style from '../utils/right-corner-style';
import * as TimeFormatter from '../utils/TimeFormatter';
import { clearUIMessage } from '../utils/UIMessageBoxes.js';
import {Card, CardTitle} from 'material-ui/Card';
import Customer from '../DataModel/Customer';



const page_bottom_white = {
  border: '25px solid white',
  backgroundColor: 'white'
};
function pow(x, y){
  return Math.pow(x, y);
}
const listStyle = {
  margin: 24
};

export default
@observer class BeaconsPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  constructor(props) {
    super(props);
      var available = new Customer();
      available.id = "Available";
      available.name = "Available";
      this.available = available;
  }

  render() {
    return (
      <PageLoading loading={AppModel.fetchingBeaconData}>
        <div style={listStyle}>
          <Subheader>{uiMsg('CML_SELECT_BEACON',"Select customer to view beacons")} :</Subheader>
            <CustomerBeaconList
              customers={[this.available]}
              /* onSelect = {this.gotoBeaconDetail.bind(this)} */
            />
            <CustomerBeaconList
              customers={AppModel.customerListIncludingOwnCompany}
              /* onSelect = {this.gotoBeaconDetail.bind(this)} */
            />

            {AppModel.canRegisterMachines?
              <FloatingActionButton style={right_corner_style}
                                  children={<Add />}
                                  onTouchTap={function(){}
                                  /* this.gotoNewMachinePage.bind(this) */} />
              :null
            }

        </div>
         

        <div style={page_bottom_white}>&nbsp;</div>
        {/* {(AppModel.canEditLocations || AppModel.canEditRooms) ?
          <FloatingActionButton style={right_corner_style}
                                children={<Add />}
                                onTouchTap={this.gotoNewLocationPage.bind(this)} />
                              : null} */}
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/BeaconsPage.jsx
 **/